// Mini renderizador de markdown para la pantalla "Acerca de". El contenido vive
// en public/acerca-de.md (editable sin recompilar, tambien en el sitio ya
// publicado). Subconjunto soportado: titulo (#), subtitulos (##), parrafos,
// listas (- ), **negrita** y [enlaces](url). Construye elementos de React, sin
// HTML inyectado. Sigue el patron de scl-vector-fields. El archivo que se lee
// depende del idioma (i18n.js: acerca-de.md o acerca-de.en.md).
import { txt } from '../i18n';

function renderizarInline(texto) {
  const partes = texto.split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g);
  return partes.map((parte, i) => {
    const negrita = parte.match(/^\*\*([^*]+)\*\*$/);
    if (negrita) return <strong key={i}>{negrita[1]}</strong>;
    const enlace = parte.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (enlace) {
      return (
        <a key={i} href={enlace[2]} target="_blank" rel="noreferrer">
          {enlace[1]}
        </a>
      );
    }
    return parte;
  });
}

export function tituloMarkdown(texto) {
  const linea = (texto || '').split('\n').find((l) => l.startsWith('# '));
  return linea ? linea.slice(2).trim() : txt('leyenda.acerca');
}

export default function MarkdownMini({ texto }) {
  const bloques = (texto || '')
    .split(/\n\s*\n/)
    .map((b) => b.trim())
    .filter(Boolean);
  return bloques.map((bloque, i) => {
    if (bloque.startsWith('# ')) return null; // el titulo lo muestra el encabezado
    if (bloque.startsWith('## ')) {
      return (
        <h3 key={i} className="markdown-subtitulo">
          {renderizarInline(bloque.slice(3))}
        </h3>
      );
    }
    const lineas = bloque.split('\n');
    if (lineas.every((l) => l.startsWith('- '))) {
      return (
        <ul key={i}>
          {lineas.map((l, j) => (
            <li key={j}>{renderizarInline(l.slice(2))}</li>
          ))}
        </ul>
      );
    }
    return <p key={i}>{renderizarInline(lineas.join(' '))}</p>;
  });
}
